import { UNEXPECTED_SERVER_RESPONSE } from '$lib/constants';
import apiHelper from '$lib/services/helper';

/**
 в данном файлике реализуем апи работы с Файлами
 */
export const EntityApi = (userToken?: string) => {

  const API_NAME = 'entity-keywords';

  const {get, post} = apiHelper(userToken);

  return {

    /* Метод для детального поиска */
    getResultsByKeywords: async (params = {}): Promise<{ data?: any, err?: string }> => {
      const { err, data } = await get(API_NAME, params);

      if (err) return {err};

      if (!data?.data || !data?.meta) {
        return {err: UNEXPECTED_SERVER_RESPONSE};
      }

      return { data: data?.data };
    },

    /* Метод для Yandex GPT поиска */
    getResultsByQuestion: async (params = {}): Promise<{ data?: any, err?: string }> => {
      const { err, data } = await post("chatbots", params);

      if (err) return {err};

      // if (!data?.data || !data?.meta) {
      //   return {err: UNEXPECTED_SERVER_RESPONSE};
      // }

      return { data: data?.data };
    }
  }
}
